export enum ServiceActionType {
  FETCH_SERVICES = "FETCH_SERVICES",
  FETCH_SERVICE_REQUEST = "FETCH_SERVICE_REQUEST",
  FETCH_SERVICE_SUCCESS = "FETCH_SERVICE_SUCCESS",
  FETCH_SERVICE_ERROR = "FETCH_SERVICE_ERROR",
  SAVE_SERVICE = "SAVE_SERVICE",
}
